import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AutoRedemptionSettingsEffects } from './store/effects/auto-redemption-settings.effects';
import { autoRedemptionSettingReducer } from './store/reducers/auto-redemption-settings.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      'autoRedemptionSettings',
      autoRedemptionSettingReducer,
    ),
    EffectsModule.forFeature([AutoRedemptionSettingsEffects]),
  ],
})
export class AutoRedemptionSettingsModule {}
